// Packages
import tw, { styled, css } from "twin.macro";

export const Container = styled.div(() => [
  css``,
  tw`relative w-full bg-cover bg-center h-[264px] md:h-[400px] lg:h-[529px]`,
]);

export const Wave = styled.div(() => [``, tw`pt-[180px] md:pt-[290px] lg:pt-[392px] xl:pt-[348px] w-full`]);

export const WaveSvg = styled.h1(() => [``, tw`absolute bottom-0 w-full`]);
